import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware, compose, combineReducers } from 'redux'
import persistState from 'redux-localstorage'
import thunk from 'redux-thunk'
import createLogger from 'redux-logger'
import { Router, Route, hashHistory } from 'react-router'
import { routerMiddleware, syncHistoryWithStore, routerReducer } from 'react-router-redux'

import 'core-js'
import 'custom-event-polyfill'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'font-awesome/scss/font-awesome';
import './styles'

import reducers from './reducers'
import routes from './routes'
import { request } from './helper/api'

// setup middleware
const middleware = [
    routerMiddleware(hashHistory), 
    thunk
]
if(process.env.NODE_ENV !== 'production') {
    middleware.push(createLogger())
}

// initialize store
const store = createStore(
    combineReducers({
        ...reducers,
        routing: routerReducer
    }),
    compose(
        persistState(['token']), //['user', 'preferences']),
        applyMiddleware(...middleware)
    )
)

let lastState = store.getState()
store.subscribe(() => {
    const state = store.getState()
    if(lastState.user && JSON.stringify(lastState.preferences) !== JSON.stringify(state.preferences)) {
        request('/preferences', {
            method: 'POST',
            data: state.preferences,
            params: { token: state.token }
        })
    }
    lastState = state
})

// Create an enhanced history that syncs navigation events with the store
const history = syncHistoryWithStore(hashHistory, store)

render(
    <Provider store={store}>
        <Router {...{ history, routes }} />
    </Provider>,
    document.getElementById('root')
)


// WEBPACK FOOTER //
// ./index.js